import { PocCheckbox } from 'commons/components/components-wrapper/poc-checkbox.component';
import React from 'react';
import { DeviceLayoutConfigSectionProperty } from '../settings-devices-configuration-layout.model';

interface CheckboxGroupComponentProps {
    property: DeviceLayoutConfigSectionProperty;
    value: unknown[];
    disabled?: boolean;
    maxSelectable?: number;
    onValueChange?: (value: string[]) => void;
}

const getCheckedValue = (val: unknown): boolean | undefined => {
    if (!Number.isNaN(Number(val))) {
        return Boolean(Number(val));
    }
    return val === undefined ? undefined : Boolean(val);
};

export const CheckboxGroupComponent: React.FC<CheckboxGroupComponentProps> = ({
    property,
    onValueChange,
    value,
    disabled,
    maxSelectable,
}) => {
    const [selectedValues, setSelectedValues] = React.useState<string[]>(value as string[]);
    const [maxSelectableReached, setMaxSelectableReached] = React.useState<boolean>(false);
    const isMultipleOptions = property.options && property.options.length > 0 && property.multiSelection;

    const handleChange = (newValue: string) => {
        if (isMultipleOptions) {
            const newValues = selectedValues.includes(newValue)
                ? selectedValues.filter((v) => v !== newValue)
                : [...selectedValues, newValue];
            setSelectedValues(newValues);
            onValueChange?.(newValues);
            setMaxSelectableReached(!!maxSelectable && maxSelectable === newValues.length);
        } else {
            onValueChange?.([newValue]);
        }
    };

    return (
        <div>
            {isMultipleOptions ? (
                property.options?.map((option) => (
                    <PocCheckbox
                        key={option.id}
                        value={option.id}
                        checked={selectedValues.includes(option.id)}
                        disabled={disabled || (!selectedValues.includes(option.id) && maxSelectableReached)}
                        onValueChange={() => handleChange(option.id)}
                    >
                        {option.description}
                    </PocCheckbox>
                ))
            ) : (
                <PocCheckbox
                    name={property.name}
                    checked={getCheckedValue(value[0])}
                    disabled={disabled || (!getCheckedValue(value[0]) && maxSelectableReached)}
                    onValueChange={(e) => handleChange(String(e.detail))}
                >
                    {property.displayName}
                </PocCheckbox>
            )}
        </div>
    );
};
